import { ChangeEvent, useState } from "react"
import { MyDispatch, MySelector } from "../../redux/store"
import { toast } from "sonner"
import { useDispatch } from "react-redux"
import { createUserProfile, joinEventAction, setUserId } from "../../redux/eventSlice"
import Loader from "../utils/Loader"

interface CreateProfileProps {
  onProfileCreated: (userId: string) => void
}

const CreateProfile = ({ onProfileCreated }: CreateProfileProps) => {
  const dispatch = useDispatch<MyDispatch>()
  const { number, loading, eventId } = MySelector((state) => state.event)
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")

  const handleFirstNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFirstName(e.target.value)
  }

  const handleLastNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setLastName(e.target.value)
  }

  const createProfile = async () => {
    if (!firstName.trim()) {
      toast.info("Please enter your first name.")
      return
    }
    if (!lastName.trim()) {
      toast.info("Please enter your last name.")
      return
    }

    try {
      const result = await dispatch(createUserProfile({
        number,
        firstName: firstName.trim(),
        lastName: lastName.trim()
      })).unwrap()

      if (result.status === "OK" && result.body?.id && eventId) {
        dispatch(setUserId(result.body.id))
        dispatch(joinEventAction({ eventId, userId: result.body.id }))
        onProfileCreated(result.body.id)
      }
    } catch (error) {
      // Error handling is already done in the redux slice
    }
  }

  return (
    <div>
      <p className="text-center font-[600] text-lg md:text-xl xl:text-2xl mb-[5px] md:mb-[8px] lg:mb-[10px] text-brightBlack dark:text-offWhite">
        Create Profile
      </p>
      <p className="text-offGrey dark:text-grey text-xs md:text-sm xl:text-lg text-center font-[400] mb-6">
        We need a few details to get you started.
      </p>

      <div className="space-y-4 mb-6">
        <div>
          <label htmlFor="firstName" className="block text-sm font-medium text-brightBlack dark:text-offWhite mb-2">
            First Name
          </label>
          <input
            id="firstName"
            type="text"
            value={firstName}
            onChange={handleFirstNameChange}
            className="w-full px-4 py-3 border border-offGrey/80 rounded-xl bg-transparent text-brightBlack dark:text-offWhite focus:outline-none focus:border-offWhite placeholder-offGrey dark:placeholder-grey"
            placeholder="Enter your first name"
            disabled={loading}
          />
        </div>

        <div>
          <label htmlFor="lastName" className="block text-sm font-medium text-brightBlack dark:text-offWhite mb-2">
            Last Name
          </label>
          <input
            id="lastName"
            type="text"
            value={lastName}
            onChange={handleLastNameChange}
            className="w-full px-4 py-3 border border-offGrey/80 rounded-xl bg-transparent text-brightBlack dark:text-offWhite focus:outline-none focus:border-offWhite placeholder-offGrey dark:placeholder-grey"
            placeholder="Enter your last name"
            disabled={loading}
          />
        </div>
      </div>

      <button
        onClick={createProfile}
        className={`w-full rounded-2xl py-[12px] lg:py-[15.5px] font-[500] leading-[19.36px] outline-none border flex justify-center items-center text-sm xl:text-base ${
          firstName.trim() && lastName.trim()
            ? "bg-blackish dark:bg-golden text-white dark:text-blackish border-golden"
            : "bg-grey dark:bg-darkGrey text-white dark:text-offGrey border-grey dark:border-darkGrey"
        }`}
        disabled={!firstName.trim() || !lastName.trim() || loading}
      >
        {loading ? <Loader /> : "Create Profile"}
      </button>
    </div>
  )
}

export default CreateProfile